import { render, staticRenderFns } from "./App.vue?vue&type=template&id=397a239c&scoped=true&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "./styles/bootstrap.css?vue&type=style&index=0&lang=css&"
import style1 from "./App.vue?vue&type=style&index=1&id=397a239c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397a239c",
  null
  
)

export default component.exports